export default __webpack_public_path__ + "static/media/mainVideo.37fd7782.mp4";